import React from 'react';
import { Constrain, Expandable } from '@moda/om';
import { SiteFooterMailingList } from '../SiteFooterMailingList';
import { SiteFooterLinksMobile } from '../SiteFooterLinks';
import { SiteFooterMobileClientServices } from './SiteFooterMobileClientServices';

import './SiteFooterMobile.scss';

export const SiteFooterMobile: React.FC = () => (
  <Constrain className="SiteFooterMobile">
    <SiteFooterMobileClientServices />

    <Expandable className="SiteFooterMobile__more" name="MORE INFORMATION">
      <SiteFooterLinksMobile />
    </Expandable>

    <a
      className="SiteFooterMobile__download"
      href="https://itunes.apple.com/us/app/moda-operandi/id781702094"
    >
      Download the Moda App
    </a>

    <div className="SiteFooterMobile__sign-up">
      <SiteFooterMailingList />
    </div>

    <div className="SiteFooterMobile__basement">
      © {new Date().getFullYear()} Moda Operandi, Inc. All Rights Reserved.
    </div>
  </Constrain>
);
